import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RegisterAccount } from "../pages/auth/register";
import { Login } from "../pages/auth/login";
import { Reset } from "../pages/auth/reset";
import {
  ChooseVerifyMethod,
  VerifyAuthApp,
  VerifyEmail,
  VerifyResetEmail,
  VerifySecQuest,
  VerifySms,
} from "../pages/auth/verify";
import { BaseContainer } from "../components/home/BaseContainer";
import { OrganizationListing } from "../pages/home/Organizarionlisting";
import { Activity } from "../pages/home/Activity";
import { Chats } from "../pages/home/Chat";
import { Help } from "../pages/home/Help";
import { Settings } from "../pages/home/Settings";
import AddOrganization from "../pages/home/AddOrganization";
import { CompanyProfile, CompanyListing } from "../pages/settings/comapny";
import { Users } from "../pages/settings/users";
import { Roles } from "../pages/settings/roles";
import { SelectedOrgModules } from "../pages/home/SelectedOrgModules";
import { ResetPass } from "../pages/auth/Changepasword";
import { Department } from "../pages/settings/department";
import { UserSettings } from "../pages/home/UserSettings";
import GeneralSettings from "../pages/orgSettings/Preferences";
import Preferences from "../pages/orgSettings/Preferences";
import Notifications from "../pages/orgSettings/Notifications";
import PassandSec from "../pages/orgSettings/PassandSec";
import { NotificationsActivity } from "../pages/activity/Notifications";
import { AuditsActivity } from "../pages/activity/Audits";
import { VerifyOtp } from "../components/Settings/VerifyOTP";
import { DeveloperMode } from "../pages/settings/developer";
import { ModularApps } from "../pages/home/Modularapps";
import { AllModules } from "../pages/orgSettings/modules/all";
import { ResetPassSettings } from "../components/Settings/Changepasword";
import SelectedModuleView from "../pages/modules/SelectedModuleView";
import { OrgDepartments } from "../pages/modules/departments/OrgDepartments";

const AdminRoute = () => {
  return (
    <Router
    //  basename="/redfrontend"
    >
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<RegisterAccount />} />
        <Route path="/reset" element={<Reset />} />
        <Route path="/verify" element={<VerifyEmail isfactor={false} />} />
        <Route path="/chooseverify" element={<ChooseVerifyMethod />} />
        <Route path="/verifysms" element={<VerifySms />} />
        <Route path="/verifyauthapp" element={<VerifyAuthApp />} />
        <Route path="/verifysecquest" element={<VerifySecQuest />} />
        <Route path="/verifyreset" element={<VerifyResetEmail />} />
        <Route path="/chagepassword" element={<ResetPass />} />
        <Route path="/home" element={<BaseContainer />}>
          <Route path="" element={<OrganizationListing />} />
          <Route path="activity" element={<Activity />}>
            <Route path="notifications" element={<NotificationsActivity />} />
            <Route path="" element={<NotificationsActivity />} />
            <Route path="audits" element={<AuditsActivity />} />
          </Route>
          <Route path="chat" element={<Chats />} />
          <Route path="help" element={<Help />} />

          <Route path=":orgid/modules" element={<SelectedOrgModules />} />
          <Route  path=":orgid/modules/:moduleId"  element={<SelectedModuleView />}  />

          <Route path=":orgid/modularapps" element={<ModularApps />}>
            <Route path="all" element={<AllModules />} />
            <Route path="" element={<AllModules />} />
            <Route path="financial" element={<Help />} />
            <Route path="costom" element={<Help />} />
            <Route path="inv" element={<Help />} />
          </Route>
          <Route path="department" element={<OrgDepartments />} />
          <Route path="settings" element={<UserSettings />}>
            <Route path="company" element={<CompanyListing />} />
            <Route path="passandsec" element={<PassandSec />} />
            <Route path="devmode" element={<DeveloperMode />} />
            <Route path="verifyemail" element={<VerifyOtp />} />
            <Route path="resetpassword" element={<ResetPassSettings />} />
            <Route path="" element={<Preferences />} />
            <Route path="users" element={<Users />} />
            <Route path="departments" element={<Department />} />
            <Route path="roles" element={<Roles />} />
            <Route path="general" element={<Preferences />} />
            <Route path="notification" element={<Notifications />} />
            <Route path="company" element={<CompanyProfile />} />
            <Route path="" element={<CompanyProfile />} />

            <Route path="users" element={<Users />} />
            <Route path="roles" element={<Roles />} />
          </Route>
          <Route path="orgsettings" element={<Settings />}></Route>
          <Route path="addorg" element={<AddOrganization />} />
        </Route>
      </Routes>
    </Router>
  );
};

export { AdminRoute };
